import { render, staticRenderFns } from "./servicetype.vue?vue&type=template&id=26886424&scoped=true"
import script from "./servicetype.vue?vue&type=script&lang=js"
export * from "./servicetype.vue?vue&type=script&lang=js"
import style0 from "./servicetype.vue?vue&type=style&index=0&id=26886424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26886424",
  null
  
)

export default component.exports